import React from 'react'
import {useEffect, useState} from 'react'
import axios from 'axios'
import { useIsFocused,useNavigation } from '@react-navigation/native';


const Customers=()=> {
  const [customers, setCustomers] = useState([]);
  const navigation = useNavigation();
  const isFocused = useIsFocused();

  useEffect(() => {
    const fetchAllCustomers = async () => {
      try {
        const res = await axios.get("https://alligensback.onrender.com/customers");
        setCustomers(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    if (isFocused) {
      fetchAllCustomers();
    }
  }, [isFocused]);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://alligensback.onrender.com/customer/${id}`);
      setCustomers(customers.filter(customer => customer.idcliente !== id));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <h1>Customers</h1>
      <div className='customers'>
        <table>
         <tr>
            <td><b>idcliente</b></td>
            <td><b>nombre</b></td>
            <td><b>direccion</b></td>
            <td><b>telefono</b></td>
            <td></td>
            <td></td>
        </tr>   
        {customers.map(customer=>(
          //<div className="customer" key={customer.idcliente}>
            <tr>
            <td>{customer.idcliente}</td>
            <td>{customer.nombre}</td>
            <td>{customer.direccion}</td>
            <td>{customer.telefono}</td>
           
             <td>
             <button className='delete' onClick={()=>handleDelete(customer.idcliente)}>Delete</button></td>
             <td><button className='update' onClick={() => navigation.navigate('UpdateCustomer',{id:customer.idcliente})}>Update</button></td>
             </tr>
        //</div>
        ))}

        <button onClick={() => navigation.navigate('Customer')}>
        Agregar
      </button>
      
      </table>
      </div>
      
    </div>
  );
}

export default Customers